import React from 'react'
import { Field } from 'formik'
import FieldWrapper from './../../FieldWrapper'
import WrapperAccordion from '../../../general/WrapperAccordion'
import ImageDisplayAndUpload from '../ImageDisplayAndUpload'
import Translation from '../../../Translation/cont/Translation'
import ImagesMovieDisplayAndUpload from '../ImagesMovieDisplayAndUpload'

const ImagesAccordion = ({values, activeTabClass, setActiveTab, title, classes, setMovieImages}) => {
    const hasPoster = values.movie.images.poster.url ? true : false
    const hasPosterId = values.movie.images.poster.id ? true : false

    return (
        <WrapperAccordion
            title={title}
            className={classes}
            selectionActiveClass={activeTabClass}
            collapseActiveSelection={setActiveTab}
            gapless={true}
        >
            <fieldset>
                <div className="form-content">
                    <div className="left-sections">
                        <FieldWrapper classes="field-wrapper-image-accordion" wrapperClasses="image-wrapper" label={<Translation id="images_movie_poster"/>} id="movie-poster" >
                            <Field 
                                name="movie.images.poster"
                                imageType="poster"
                                component={ImageDisplayAndUpload}
                                />
                            {hasPoster && hasPosterId && <>
                                <p className='text-small-light'><Translation id={'y-axis'}/></p>
                                <div className="slidecontainer">
                                    <Field type="range" step="1" min="0" max="100" name="movie.images.poster.positionY" className="text-regular range-slider input-text-box gap-10" />
                                </div>
                                <p className='text-small-light'><Translation id={'x-axis'}/></p>
                                <div className="slidecontainer">
                                    <Field type="range" step="1" min="0" max="100" name="movie.images.poster.positionX" className="text-regular range-slider input-text-box" />
                                </div>
                            </>}
                        </FieldWrapper>
                    </div>

                    <div className="right-sections">
                        <div className="right-sections">
                            <FieldWrapper description={<Translation id="images_movie_wallpapers_info"/>} label={<Translation id="images_movie_wallpapers"/>} id="movie-backgrounds" classes="image-displaygrid-upload" >
                                <Field
                                    name="movie.images"
                                    imageType="background"
                                    component={ImagesMovieDisplayAndUpload}
                                    setMovieImages={setMovieImages}
                                />
                            </FieldWrapper>
                        </div>
                    </div>
                </div>
            </fieldset>
        </WrapperAccordion>
    )
}

export default ImagesAccordion